import React from 'react';
import cx from 'classnames';
import { useForm } from 'react-hook-form';

import { Input } from '../../Input';
import InputPhone from '../../InputPhone';
import { useAuth0 } from '../../../context/auth0';
import { TRANSLATIONS } from '../../../../translations';

const ModalForm = ({ onSubmit, prefixesAreVisible, alertMessage }) => {
  const { handleSubmit, register, errors, watch } = useForm();

  const handlePrivacyClick = () => {
    document.getElementById('iubenda-privacy-trigger').click();
  };

  const { isAuthenticated, loginWithRedirect } = useAuth0();

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
      <p className={'text-center'}>{app_main_wpml.create_account}</p>

      {alertMessage != false && (
        <div className="Alert__message--error modal-alert">
          <span>
            {app_main_wpml.cannot_complete_subscription};{' '}
            {app_main_wpml.if_account_yet}{' '}
            <a
              onClick={() => {
                isAuthenticated ? null : loginWithRedirect();
              }}
            >
              {app_main_wpml.login.toLowerCase()}
            </a>
            , {app_main_wpml.if_need_help}{' '}
            <a href={app_main_wpml.contacts_link} target="_blank">
              {app_main_wpml.contact_us}
            </a>
          </span>
        </div>
      )}

      <Input
        label={TRANSLATIONS.BUSINESS_NAME}
        className={'input__modal'}
        name="business_name"
        errored={!!errors['business_name']}
        setRef={register({
          required: true,
        })}
      />

      <Input
        label={`${app_main_wpml.first_name}*`}
        className={'input__modal'}
        name="first_name"
        errored={!!errors['first_name']}
        setRef={register({
          required: true,
        })}
      />

      <Input
        label={`${app_main_wpml.last_name}*`}
        className={'input__modal'}
        name="last_name"
        errored={!!errors['last_name']}
        setRef={register({
          required: true,
        })}
      />

      <Input
        label={app_main_wpml.Email + '*'}
        className={'input__modal'}
        name="email"
        errored={!!errors['email']}
        setRef={register({
          required: true,
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          },
        })}
      />

      <Input
        label={TRANSLATIONS.PASSWORD}
        type="password"
        className={'input__modal'}
        name="password"
        errored={!!errors['password']}
        setRef={register({
          required: true,
          pattern: { value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/ },
        })}
      />

      <div className="hint">{app_main_wpml.password_check}</div>

      <InputPhone
        className={'input__modal'}
        errored={!!errors['phone']}
        label={TRANSLATIONS.PHONE}
        name="phone"
        setRef={register({
          required: true,
          minLength: 8,
        })}
      />

      <Input
        label={TRANSLATIONS.WEBSITE}
        className={'input__modal'}
        name="website"
        errored={!!errors['website']}
        setRef={register({
          required: false,
        })}
      />

      <div
        className={cx('fake-checkbox', {
          'fake-checkbox--errored': !!errors.privacy,
        })}
        style={{ marginLeft: 5, marginTop: 5 }}
      >
        <input
          className="fake-checkbox__input"
          type="checkbox"
          name="privacy"
          ref={register({ required: true })}
          id="partner-signup-privacy"
        />
        <label
          htmlFor="partner-signup-privacy"
          className="fake-checkbox__label"
        >
          <span class="iconify inline" data-icon="mdi:check-bold"></span>
        </label>
        <p className="fake-checkbox__text">
          {app_main_wpml.privacy_acceptance}{' '}
          <span className="fake-checkbox__link" onClick={handlePrivacyClick}>
            {app_main_wpml.privacy_cta}
          </span>
        </p>
      </div>

      <button type="submit" className="btn btn--primary btn--expanded">
        {app_main_wpml.signup}
      </button>
    </form>
  );
};

export default ModalForm;
